import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { ProposalOutflowsSectionSkeleton } from 'Organisms/ProposalOutflowsSection/ProposalOutflowsSectionSkeleton';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ProposalOutflowsSection } from './ProposalOutflowsSection';

const useStyles = buildUseStyles('ProposalInflowsSectionContainer', () => ({
  root: {
    width: '100%',
  },
}));

export const ProposalOutflowsSectionContainer = ({ relationship }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship);
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <DataContainer
      className={classes.root}
      component={ProposalOutflowsSection}
      componentProps={{
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={ProposalOutflowsSectionSkeleton}
    />
  );
};

ProposalOutflowsSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
